
import Vue from 'vue';

Vue.prototype.$teaLog = {
    event(...argus) {
        window.collectEvent(...argus);
    }
}
